import { AxiosError } from "axios";
import { IntlMessageId } from "../assets/localization/types";
import { prefixes } from "../assets/localization/utils";
import flowioast, {
  ToastFailureIdBase,
  ToastSuccessIdBase,
} from "../utils/flowioast";
import staticIntl from "../utils/intl/staticIntl";
import { AxiosResponse } from "./axiosWrapper";

export const FETCH_ERROR = "⚠";

const doesSuccessMsgExistForErrorIntlBase = (
  errorIntlBase: ToastFailureIdBase
) => {
  const intlId = `${prefixes.toast}.${errorIntlBase}.success` as IntlMessageId;
  return !!staticIntl.messages[intlId];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const finalizeRequestCreator = <Params extends any[], ResolveValue>(
  request: (...params: Params) => AxiosResponse<ResolveValue>,
  errorIntlBase: ToastFailureIdBase
): ((...params: Params) => Promise<ResolveValue | typeof FETCH_ERROR>) => {
  const wrappedFn = (
    ...params: Params
  ): Promise<ResolveValue | typeof FETCH_ERROR> =>
    request(...params).then(
      (response) => {
        if (doesSuccessMsgExistForErrorIntlBase(errorIntlBase)) {
          flowioast.success.fromIntlBase(errorIntlBase as ToastSuccessIdBase);
        }

        return response.data;
      },
      (error) => {
        // 401 is thrown when user has missing mapping, there is gonna be modal to signalize need for mapping
        if ((error as AxiosError).response?.status === 401) return FETCH_ERROR;

        flowioast.error.fromIntlBase(errorIntlBase, error);
        return FETCH_ERROR;
      }
    );

  return wrappedFn;
};
